import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { PlayStoreButton } from "./PlayStoreCTA";

const DISMISS_KEY = "wa_app_banner_dismissed";

// Sticky bottom banner shown ONLY on Android mobile-web, nudging visitors to
// pre-register on Google Play. Dismissable (persisted). Hidden on the listing
// detail page which already has its own sticky CTA.
export function MobileAppBanner() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent || "");
    const dismissed = localStorage.getItem(DISMISS_KEY) === "1";
    setShow(isAndroid && !dismissed);
  }, []);

  if (!show || location.pathname.startsWith("/woning/")) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  return (
    <div
      data-testid="mobile-app-banner"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-white/95 px-3 py-2.5 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur sm:hidden"
    >
      <div className="flex items-center gap-3">
        <img src="/woningalert-icon.png" alt="WoningAlert" className="h-10 w-10 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-bold text-navy">WoningAlert-app</p>
          <p className="truncate text-xs text-slate-500">Wees er als eerste bij — pre-registreer gratis</p>
        </div>
        <PlayStoreButton placement="mobile_sticky" label="Pre-registreer" className="shrink-0 px-4 py-2 text-sm" />
        <button
          onClick={dismiss}
          data-testid="mobile-app-banner-dismiss"
          aria-label="Sluiten"
          className="ml-0.5 rounded-full p-1 text-slate-400 hover:text-slate-600"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
